import React from 'react';
import { useRoutes } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import ChangePassword from 'features/auth/routes/ChangePassword';
import useUserStore from 'store/useUserStore';
import { Loader } from '@urbantxt/loader';
import mcpLoginRoute from './mcpLoginRoute';
import legalRoutes from './legalRoutes';
import publicRoutes from './public';
import { protectedRoutes, sclaReaderProtectedRoutes } from './protected';

export default function AppRoutes() {
  // check for authorized user
  const { isDone } = useAuth();

  // fetch user profile
  const user = useUserStore(s => s.user);

  // Determine which routes to use based on conditions
  let routes;
  if (user && user.mustChangePassword) {
    // Force password change - redirect all routes to change password
    routes = [
      mcpLoginRoute,
      ...legalRoutes,
      {
        path: '/*',
        element: <ChangePassword />,
      },
      {
        path: '/change-password',
        element: <ChangePassword />,
      },
    ];
  } else if (user && user.type === 'scla-app-reader') {
    // Reader-only tree (see access/routeAccess.config.ts); avoids mounting staff routes.
    routes = [mcpLoginRoute, ...legalRoutes, ...sclaReaderProtectedRoutes];
  } else {
    // render protected routes if we have token
    routes = user
      ? [mcpLoginRoute, ...legalRoutes, ...protectedRoutes]
      : [mcpLoginRoute, ...legalRoutes, ...publicRoutes];
  }

  // create routes - must be called unconditionally
  const element = useRoutes([...routes]);

  if (isDone) {
    return element;
  }

  // render
  return <Loader theme="dark" isVisible fullscreen />;
}
